export default {
  common: {
    appname: 'FFmembers',
    signup: '登録する',
    signin: 'ログイン',
    signout: 'ログアウト',
    save: '保存',
    update: '変更',
    edit: '編集',
    add: '追加',
    close: '閉じる',
    copy: 'コピー',
    download: 'ダウンロード',
    ok: 'OK',
    cancel: 'キャンセル',
    agree: '同意する',
    disagree: '同意しない',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    select: '選択',
    send: '送信',
    resend: '再送信',
    create: '作成',
    delete: '削除',
    back: '戻る',
    next: '次へ',
    fix: '確定',
    backToHome: 'トップへ戻る',
    order: '注文する',
    determine: '確定',
    soldout: '売り切れ',
    male: '男性',
    female: '女性',
    others: 'その他',
    none: 'なし',
    year: '年',
    month: '月',
    day: '日',
    cm: 'cm',
    kg: 'kg',
    previousPage: '前ページ',
    nextPage: '次ページ',
    showingPage:
      '<span class="font-medium">{total}</span> 件中 <span class="font-medium">{from}</span> から <span class="font-medium">{to}</span> 件までを表示',
    required: '必須',
    unitPrice: '単価',
    amount: '数量',
    amountMoney: '金額',
    taxIncluded: '税込',
    taxExcluded: '税抜',
    creditCard: 'クレジットカード',
    zipCode: '〒',
    tel: 'TEL',
    all: 'すべて',
    copyright: '2020 AIVICK Inc.',
    termsOfService: '利用規約',
    termsStoreSalesOfService: '店舗販売利用規約',
    termsAgentSalesOfService: '代理販売利用規約',
    termsAgentSalesTelAndFaxOfService: '電話・FAX注文モデル利用規約',
    termsAffiliateOfService: 'アフィリエイト利用規約',
    privacyPolicy: 'プライバシーポリシー',
    honorificTitle: '様',
    times: '回',
    nth: '回目',
    people: '名',
    set: 'セット',
    piece: '個',
    cumulative: '累計',
    copied: 'コピーしました。',
    qrcode: 'QRコード',
  },
  aivickinfo: {
    company: '株式会社AIVICK',
    ceo: '矢津田 智子',
    zip: '〒601-8471',
    address: '京都府京都市南区八条町416米澤京都八条ビル6F',
    supportemail: 'ffm-support@tavenal.com',
    tel: '075-634-9125',
    fax: '075-634-9124',
  },
  footer: {
    brand: 'ブランドサイト',
    commercialTransaction: '特定商取引法について',
    payment: 'お支払いについて',
    inquiry: 'お問い合わせ',
  },
  login: {
    title: 'ログイン',
    navigateToSignup: 'アカウントをお持ちでないですか？',
    forgotPassword: 'パスワードをお忘れですか？',
  },
  signup: {
    title: '会員登録',
    navigateToLogin: 'すでにアカウントをお持ちですか?',
    agreeToPolicyRequired: '利用規約・プライバシーポリシーへの同意',
    terms: '{0}・{1}・{2}・{3}に同意する。', // TODO UI考える
    emailSetting:
      '【no-reply@tavenal.com】からのメールが受信できるように、迷惑メールの設定を確認してください。',
    passwordFormat: 'アルファベット大文字と小文字、数字を含む８文字以上',
  },
  partnersignup: {
    title: 'パートナーお申し込み',
    prefNote: '郵便番号をご入力いただくと都道府県は自動的に設定されます。',
    baseInfo: '基本情報',
    storeInfo: '店舗情報',
    contractInfo: '契約情報',
    completed: '完了',
    nthStore: '{nth}つ目の店舗',
    completedMessage: '申込が完了しました',
    terms: '{0}{1}{2}{3}に同意する。',
    agreeToPolicyRequired: '利用規約・プライバシーポリシーへの同意',
  },
  storesignup: {
    title: '店舗担当者会員登録',
  },
  signupcomplete: {
    title: '会員登録の完了',
    thankyou:
      ' ご登録ありがとうございます。<br/>会員登録が完了しましたので、下記よりログイン画面へお進みください。',
    navigateToLogin: 'ログイン画面へ',
  },
  signupexpired: {
    title: '会員登録の有効期限切れ',
    message:
      ' 会員登録の有効期限が過ぎました。<br/>お手数をおかけしますが、下記よりもう一度会員登録をお願いします。',
    navigateToRegister: '会員登録画面へ',
  },
  signupalreadydone: {
    title: '会員登録の完了',
    message:
      ' すでに会員登録は完了しています。<br/>下記よりログイン画面へお進みください。',
    navigateToLogin: 'ログイン画面へ',
  },
  signupinvalid: {
    title: '会員登録エラー',
    message:
      ' メールアドレスの認証ができませんでした。<br/>URLにお間違いないかご確認の上、再度認証を行ってください。',
  },
  forgotpassword: {
    title: 'パスワード再設定',
    description:
      '登録されているメールアドレスを入力してください。パスワード再設定用メールをお送りします。',
    sendEmailSuccessMessage: 'パスワード再設定用リンクをメールで送信しました',
    sendSuccess: 'メールを送信しました',
  },
  resetpassword: {
    title: 'パスワード再設定',
    description: '新しいパスワードを入力し、パスワードを再設定します。',
    resetSuccess: 'パスワードを再設定しました',
  },
  updatepassword: {
    title: 'パスワード変更',
    description: '新しいパスワードを入力し、パスワードを再設定します。',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    newPasswordConfirm: '新しいパスワード（確認）',
    updateSuccess: 'パスワードを変更しました',
  },
  verify: {
    title: 'メールアドレス確認',
    subtitle: '次のメールアドレスに認証用のメールを送信しました:',
    description:
      'メールを確認し、メール本文内の認証用のリンクをクリックしてください。',
    resendSuccess: 'メールを再送信しました',
  },
  terms: {
    storesales: {
      title: 'パートナー利用規約(店舗販売)',
    },
    agentsales: {
      title: 'パートナー利用規約(代理販売)',
    },
    agentsalestelandfax: {
      title: 'パートナー利用規約(電話・FAX注文モデル)',
    },
    affiliate: {
      title: 'パートナー利用規約(アフィリエイトモデル)',
    },
  },
  commercialtransaction: {
    title: '特定商取引法について',
  },
  partner: {
    title: 'パートナー設定',
  },
  partnerinfo: {
    title: 'パートナー情報',
    basic: '基本情報',
    name: 'パートナー名',
    partnerCode: 'お客様管理番号',
  },
  account: {
    title: '個人設定',
  },
  profile: {
    title: '会員基本情報',
    basicinfo: '基本情報',
    emailInfo: 'メールアドレス情報',
    passwordInfo: 'パスワード情報',
  },
  creditcard: {
    title: 'クレジットカード情報',
    addCard: '新規カード登録',
    cardRequired:
      'クレジットカードはまだご登録されていません。<br>商品のご注文には、クレジットカードのご登録が必要です。',
    mainCard: 'ご利用になるクレジットカード',
    cardType: 'ブランド',
    cardName: '名義',
    cardExp: '有効期限',
    cardLast4: 'カード番号（下4桁）',
    confirmDelete: '登録されているクレジットカードを削除してもよろしいですか？',
  },
  validations: {
    password:
      'パスワードはアルファベットの大文字と小文字、数字を含む８文字以上にしてください',
    passwordConfirm: 'パスワードは同じ値を入力してください',
    tel: '正しい電話番号を入力してください',
    zip: '正しい郵便番号を入力してください',
    kana: '{_field_}はカタカナで入力してください',
    float: '小数点第一までの数値で入力してください',
    yamato:
      '全角文字の場合は{length}文字以内にしてください。長い場合は半角カナをご利用ください。',
    yamatoInvalidChars:
      '利用できない文字が含まれています。利用できる文字は、英数字（全角、半角）、かな文字、カタカナ（全角、半角）、漢字、一部の記号です。顔文字や特殊な記号などは利用できません。',
    zipNotFound: '存在しない郵便番号です',
    bankAccount:
      '口座名義は、全角カタカナ（大文字）、アルファベット（大文字）、数字、記号で入力してください。使用可能な記号は().-/「」（）ー／およびスペースです。',
  },
  errors: {
    unknown: 'エラーが発生しました。',
    sessionTimeout:
      'セッションタイムアウトが発生しました。再度、認証を行って下さい。',
  },
  shippingAddresses: {
    title: '配送先一覧',
    basicinfo: '配送先情報',
    recipientName: '受取人名',
    recipientNameL: '受取人（姓）',
    recipientNameF: '受取人（名）',
    name: '配送先名',
    destinationName: 'お届け先名',
    companyDepartment: 'お届け先会社・部門',
    zipCode: '郵便番号',
    prefId: '都道府県',
    address1: '市区町村・番地・号',
    address2: '建物・号室',
    phone: '電話番号',
    main: 'デフォルト配送先',
    add: '配送先を追加する',
    // ラベル
    addressList: '配送先一覧',
    notRegister: '配送先はまだ登録されていません',
    changeMain: 'デフォルトに変更',
    doDelete: '配送先を削除してもよろしいですか？',
    shippingAddressesRequired:
      '配送先はまだご登録されていません。<br>商品のご注文には、配送先のご登録が必要です。',
    nameNote:
      'お客様が管理しやすい名称を入力してください。商品のお届け先としては利用されません。',
    prefNote: '郵便番号をご入力いただくと都道府県は自動的に設定されます。',
  },
  shippingAddressCreate: {
    title: '配送先作成',
  },
  shippingAddressEdit: {
    title: '配送先編集',
  },
  partnerShippingAddressList: {
    title: 'パートナー配送先一覧',
    notFound: '現在、配送先は登録されていません。',
  },
  partnerShippingAddressCreate: {
    title: 'パートナー配送先作成',
  },
  partnerShippingAddressEdit: {
    title: 'パートナー配送先編集',
  },
  partnerAgentDestinationList: {
    title: '代理販売お届け先一覧',
    add: 'お届け先を追加する',
    confirmDelete: 'お届け先を削除してもよろしいですか？',
    notFound: '現在、お届け先は登録されていません。',
  },
  partnerAgentDestinationCreate: {
    title: '代理販売お届け先作成',
    basicInfo: '基本情報',
  },
  partnerAgentDestinationEdit: {
    title: '代理販売お届け先編集',
  },
  partnerStoreOwnerList: {
    title: '店舗担当者一覧',
    storeInCharge: '担当店舗',
    notFound: '現在、店舗担当者はいません。',
    urlOfStoreOwnerRegister: '店舗担当者登録URL',
    editStoreInCharge: '担当店舗設定',
  },
  partnerStoreOwnerDetail: {
    title: '担当店舗設定',
    basicInfo: '担当店舗情報',
  },
  partnerBankAccountList: {
    title: '銀行口座一覧',
    partnerBankAccount: 'パートナー口座',
    storeBankAccount: '店舗口座',
    bankAccountNotRegistered: '銀行口座は登録されていません。',
    confirmDelete: '銀行口座を削除してもよろしいですか？',
  },
  partnerBankAccountCreate: {
    title: 'パートナー銀行口座登録',
  },
  partnerBankAccountEdit: {
    title: 'パートナー銀行口座編集',
  },
  storeBankAccountCreate: {
    title: '店舗銀行口座登録',
  },
  storeBankAccountEdit: {
    title: '店舗銀行口座編集',
  },
  bankAccountCreate: {
    basicInfo: '基本情報',
  },
  services: {
    title: 'サービス一覧',
    pleaseSelectService: 'ご利用されるサービスを選択してください',
    logo: 'ロゴ',
    name: 'メンバー名',
    memberCode: 'メンバーコード',
  },
  serviceHome: {
    title: 'サービスHOME',
    salesProduct: '販売中の商品',
    productImageNote:
      '※ 写真は商品のイメージです。セットに含まれるメニューは写真を押して詳細をご確認ください。',
  },
  ffpAgentHome: {
    title: '商品のご注文',
    note: '※ 写真は商品イメージです。',
    quantityNote: '※ 1回でお届けするセット数を入力してください。',
    shippingDeliveryNote: '※ エリアによって最短お届け日は異なります。',
    zipcodeRequired: '先にお届け先を入力してください',
    deliveryDateRequired: 'お届け曜日を入力してください',
    orderCompleted: 'ご注文が完了しました',
    cantOrder: '現在、ご注文ができません。以下の登録情報をご確認ください。',
    notRegisterCreditCard: 'ご注文に使用するクレジットカードをご登録ください。',
    agreeToPolicyRequired: '利用規約・プライバシーポリシー',
    terms: '{0}・{1}への同意を確認しました。',
    termsNote: '※ 商品を受け取るお客様自身の同意が必要です。',
    destinationPickerTitle: 'お届け先選択',
    selectFromSavedRecipient: 'お届け先を追加・選択',
    doUpdateDestination: 'お届け先に変更がありました。以下に更新しますか？',
    destinationNotFound: '保存済みのお届け先はございません。',
    selectStoreOfDestination: 'お届け先の店舗を選択してください。',
    selectDestinationNote: 'お届け先を新規追加、もしくは選択してください。',
    maxItemQuantityNote: '※最大{quantity}個まで適用',
    deliverySchedule: '{n}回目お届け予定日',
    fixSchedule: '{n}回目お支払予定日',
    price: {
      list: '商品合計',
      discount: '割引額',
      shipping: '送料',
      tax: '消費税',
      gross: '合計金額',
    },
    orderNote:
      '■ご注文/キャンセルについて<br>【日曜日】がご注文締切日となり、その週の金曜日に商品を発送いたします。<br>ご注文のキャンセルはパートナー店舗様がメニューの注文履歴から可能です。',
  },
  agentSalesDocuments: {
    title: '各種ドキュメント',
    subtitle: '代理販売モデルをご契約のパートナー様へ',
    purchaseForm: '商品お申し込み書',
    purchaseFormNote:
      'お届けする地域によって、お届け可能な日時が異なります。 <br/>どちらのタイプかご不明な場合は、お届け先の郵便番号を指定してダウンロードください。',
    purchaseFormHint: 'お届け先の郵便番号を指定してダウンロード',
    purchaseFormA: 'お申し込み書（エリア Aタイプ：土日月 お届け）',
    purchaseFormB: 'お申し込み書（エリア Bタイプ：日月火 お届け）',
    normalType: '通常版',
    discountType: '割引版',
    notSupportedArea: 'ご指定の郵便番号は現在対象外です',
    recipientTerms: 'プライバシーポリシー・利用規約',
    recipientTermsNote:
      '代理販売では商品を受け取るお客様の同意が必要です。<br>商品お申込書等でご注文いただく場合は事前にこちらのPDFをダウンロードし、お客様にご確認いただくようお願いいたします。',
    recipientTermsPdf: 'プライバシーポリシー・利用規約(PDF)',
  },
  memberUser: {
    externalId: '外部ID',
    type: '担当者／オーナー',
  },
  product: {
    name: '商品名',
  },
  order: {
    orderedAt: '注文日時',
    canceledAt: 'キャンセル日時',
    orderNo: '注文番号',
    deliveryDate: 'お届け希望日',
    deliveryTimeSlot: 'お届け希望時間',
    recipientName: 'お届け先名',
    shippingAddress: 'お届け先',
    phone: '電話番号',
    email: 'メールアドレス',
    store: '注文店舗',

    productInfo: '商品情報',
    setContent: '【セット内容】',
    totalProductPrice: '商品合計',
    totalPrice: '合計金額',
    paymentPrice: '手数料',
    shippingPrice: '送料',
    tax: '消費税',
    totalPriceIncludeTax: '合計金額',
    price: {
      gross: '合計金額',
      tax: '消費税',
      discount: '割引',
      list: '商品合計',
    },
    thanksOrder:
      '<p class="text-center">ありがとうございました。</p><p class="text-center"> 商品のご注文が確定いたしました。</p>',
    productOrder: '商品注文',
    shippingFee: '送料',
    paymentMethod: 'お支払い方法',
    paymentMethodBank: '銀行振り込み',
    cancelDeadline: 'キャンセル可能日',
    oneTimePayment: '一括',
    canCancelUntil: 'まで',
    doOrder: '商品を注文してよろしいですか？',
  },
  orderHistory: {
    title: '注文履歴',
    cancelNote:
      'キャンセルボタンが表示されていない場合、キャンセル可能期限を過ぎているためキャンセルはできません。',
    cancel: '注文キャンセル',
    canCancelUntil: 'までキャンセル可能です',
    doCancelOrder: '注文をキャンセルしますか？',
    cancelCompleted: 'キャンセルが完了しました',
    notFoundHistory: '現在、注文履歴はございません',
  },
  agentOrderHistory: {
    deliverySchedule: 'お届け予定',
    deliveryTime: 'お届け日時（{n}回目）',
    doCancelItem: '商品をキャンセルしますか？',
    cancelCompleted: 'キャンセルが完了しました',
    historyNotFound: '現在、注文履歴はございません',
  },
  subscriptionList: {
    title: '定期配送申込一覧',
    notFound: '定期配送申込が見つかりませんでした。',
  },
  ffGoodsDetail: {
    title: '商品内容',
    material: '原材料',
    allergen: 'アレルギー',
    additive: '添加物',
  },
  ffGoodsList: {
    notFoundSalesGoods: '現在販売中の商品はございません。',
    cantOrder: '現在、ご注文ができません。以下の登録情報をご確認ください。',
    notRegisterShippingAddress: 'お届けする配送先をご登録ください。',
    notRegisterCreditCard: 'ご注文に使用するクレジットカードをご登録ください。',
  },
  ffpAgentOrder: {
    store: '注文店舗',
    recipient: 'お届け先（お客様）',
    deliveryOptions: 'お届け方法',
    paymentMethod: 'お支払方法',
    productList: 'ご注文商品',
    creditCardNote:
      '※ クレジットカードは毎週月曜日の決済時点でご登録いただいているものが使用されます。',
    confirmMessage:
      '以下の予定で商品をお届けします。<br>お間違えなければ「確定」ボタンを押してください。',
  },
  contact: {
    title: 'お問い合わせ',
    description:
      '受付時間　24時間365日<br>' +
      '尚、返信は弊社の営業時間内（平日10～17時）に行います。<br>' +
      '現在、ご返答までにお時間を頂く場合がございます。<br>' +
      '恐れ入りますが、返答を差し上げますまでお待ちくださいますようお願い申し上げます。',
    complete: 'お問い合わせを受け付けました。',
  },
  contactComplete: {
    title: 'お問い合わせ完了',
    message:
      'お問い合わせありがとうございます。<br>内容を確認いたしますので、ご返答まで今しばらくお待ちください。',
  },
  affiliate: {
    title: 'アフィリエイト報酬',
    customerCount: '会員獲得数',
    boughtCount: '獲得購入数',
    bonus: '報酬額',
    cumulativeCustomerCount: '累計<br>会員獲得数',
    cumulativeBoughtCount: '累計<br>獲得購入数',
    cumulativeBonus: '累計<br>報酬額',
    taxHint: '※表示金額はすべて税抜です。',
    affiliateHint:
      '※ 出荷日をベースとして計算しておりますので、月の後半に購入された場合は翌月の報酬となります。詳しくは<a href="https://fitfood.jp/manual/partners-model/152/" target="_blank" class="text-link hover:text-link-hover">こちら</a>をご覧ください。',
    salesPromotionTool: 'アフィリエイト販促用ツール',
    invitationCode: 'あなたの招待コード',
    invitationCodeHint:
      '※ ご紹介様が会員登録される際に、こちらのコードを入力いただくことで「あなたのお客様」として登録が完了します。',
    invitationLink: '招待コード入りリンク',
    invitationLinkHint:
      '※ こちらのURLにアクセスすると、会員登録画面の招待コード欄に「あなたの招待コード」が自動で入力されます。<br>お客様に会員登録のご案内をされる際はこちらのURLをご利用ください。',
    outOfRange: '報酬対象期間外です',
    set: 'セット',
    retail: '単品',
  },
  notFound: {
    title: 'お探しのページが見つかりませんでした',
    description:
      '大変申し訳ございませんが、あなたがアクセスしようとしたページは削除されたかURLが変更されています。',
    backToTop: 'TOPへ戻る',
  },
  fields: {
    zipcode: '郵便番号',
    pref: '都道府県',
    address1: '住所1',
    address2: '住所2',
    phone: '電話番号',
    user: {
      email: 'メールアドレス',
      password: 'パスワード',
      passwordConfirm: 'パスワード（確認）',
    },
    profile: {
      firstName: '名',
      lastName: '姓',
      userName: 'お名前',
      firstNameKana: 'メイ',
      lastNameKana: 'セイ',
      userNameKana: 'フリガナ',
      gender: '性別',
      birthday: '生年月日',
      height: '身長',
      weight: '体重',
    },
    contact: {
      contactType: '種別',
      contents: '内容',
    },
    agentSalesOrder: {
      agentSalesOrderId: '注文ID',
      consumerPartnerId: 'パートナーID',
      consumerUserId: '会員ID',
      orderNo: '注文番号',
      status: '状態',
      deliveryFrequency: 'お届け頻度',
      numberOfDeliveries: '全お届け回数',
      deliveryDayOfWeek: 'お届け曜日',
      deliveryTimeSlot: 'お届け希望時間',
      shippingAddress: '配送先住所',
      totalPriceIncludeTax: '合計金額（税込）',
      orderedAt: '注文日時',
      canceledAt: 'キャンセル日時',
      consumerPartner: {
        name: 'パートナー名',
      },
      consumerUser: {
        name: '会員名',
        nameKana: '会員名（フリガナ）',
        email: 'メールアドレス',
      },
      recipient: {
        address: 'お届け先住所',
        name: '受取人名',
        nameKana: '受取人名（フリガナ）',
        phone: '電話番号',
        email: 'メールアドレス',
      },
      amount: '決済額（税込）',
      memo: 'メモ',
    },
    agentSalesOrderItem: {
      shippingItem: {
        deliveryDate: 'お届け日',
        deliveryTimeSlot: 'お届け時間',
      },
    },
    subscription: {
      consumerStore: '店舗名',
      applicationNo: '申込番号',
      applicationDate: '申込受付日',
      status: '状態',
      paymentMethod: '支払方法',
      recipient: {
        address: 'お届け先住所',
        name: '受取人名',
        nameKana: '受取人名（フリガナ）',
        phone: '電話番号',
        email: 'メールアドレス',
      },
      deliveryFrequency: 'お届け頻度',
      numberOfDelivery: 'お届け回数',
      deliveryDayOfWeek: 'お届け曜日',
      deliveryTimeSlot: 'お届け時間帯',
      firstShippingDate: '初回出荷日',
      finishedAt: '契約終了日',
    },
    subscriptionItem: {
      product: '商品',
      quantity: '数量',
    },
    affiliate: {
      productLabel: '商品種別',
      normalPurchase: '都度購入',
      periodicPurchase: '定期購入',
      bonus: '報酬額',
      cumulativeBonus: '累計報酬額',
    },
    store: {
      name: '店舗名',
    },
    partnerApplication: {
      appliedAt: '申込日時',
      applicantName: '申込者氏名',
      applicantFirstName: '申込者氏名(名)',
      applicantLastName: '申込者氏名(姓)',
      applicantEmail: '申込者メールアドレス',
      referrer: 'ご紹介者様名',
      companyName: '会社名',
      ownerName: '代表者名',
      phone: '電話番号',
      siteUrl: '会社ウェブサイトURL',
      status: 'ステータス',
      useAffiliate: 'アフィリエイトモデル',
      servicePlanIds: 'サービスプランID',
      storeCount: '店舗数',
      servicePlans: {
        name: 'お申し込みモデル',
      },
    },
    storeApplication: {
      name: '店舗名',
      siteUrl: '店舗ウェブサイトURL',
      industryId: '業務ID',
      industryFreeWord: 'その他',
    },
    industry: {
      name: '業務内容',
    },
    partnerBankAccount: {
      partnerBankAccountId: '銀行口座ID',
      bankName: '銀行名',
      branchNumber: '支店番号',
      branchName: '支店名',
      accountName: '口座名義（カナ）',
      accountNumber: '口座番号',
      accountType: '預金種目',
    },
  },
  placeholders: {
    firstName: '花子',
    lastName: '健康',
    firstNameKana: 'ハナコ',
    lastNameKana: 'ケンコウ',
    address1: '〇〇市〇区1番地',
    address2: '〇〇ビル6F',
    zipcode: '000-0000',
    phone: '00000000000',
    email: 'example@tavenal.com',
    url: 'https://example.com',
    user: {
      password: '',
      passwordConfirm: 'もう一度入力してください',
    },
    profile: {
      height: '157.0',
      weight: '50.0',
    },
    shippingAddress: {
      name: '〇〇会社、〇〇事務所、自宅等',
      destinationName: '健康花子',
      companyDepartment: '株式会社〇〇',
    },
    contact: {
      contents: 'お問い合わせ内容を記載してください。',
    },
    partnerApplication: {
      companyName: '株式会社〇〇',
    },
    storeApplication: {
      industryFreeWord:
        'その他（当てはまるものがない場合、業務内容を記述ください）',
    },
    bankAccount: {
      bankName: '○○銀行',
      branchNumber: '123',
      branchName: '○○支店',
      accountNumber: '1234567',
      accountName: 'ケンコウ　ハナコ',
    },
  },
  enums: {
    unknown: '不明',
    xDayOfWeek: {
      sunday: '日曜日',
      monday: '月曜日',
      tuesday: '火曜日',
      wednesday: '水曜日',
      thursday: '木曜日',
      friday: '金曜日',
      saturday: '土曜日',
    },
    deliveryfrequency: {
      everyweek: '毎週',
      everyotherweek: '隔週',
    },
    serviceplantype: {
      storesales: '店舗販売',
      agentsales: '代理販売',
    },
    deliverytimeslot: {
      slotNone: '指定なし',
      slotAM: '午前中',
      slot1416: '14時〜16時',
      slot1618: '16時〜18時',
      slot1820: '18時〜20時',
      slot1921: '19時〜21時',
    },
    orderStatus: {
      new: '新規受付',
      fixed: '確定',
      readyToShip: '出荷準備中',
      shipped: '出荷済み',
      cancelled: 'キャンセル済',
    },
    agentSalesOrderStatus: {
      new: '新規',
      charged: '決済済',
      processing: '継続中',
      completed: '完了',
      canceled: 'キャンセル済',
    },
    agentSalesShippingItemStatus: {
      new: '商品準備中',
      ordered: '受注済み',
      fixed: '受注確定',
      failed: '決済失敗',
      canceled: 'キャンセル済み',
    },
    subscriptionStatus: {
      beforeContract: '新規受付',
      contracted: '契約中',
      finished: '契約終了',
    },
    paymentMethod: {
      credit: 'クレジットカード',
      bank: '銀行振り込み',
      np: 'NP後払い',
    },
    memberType: {
      owner: 'オーナー',
      storeOwner: '店舗担当者',
    },
    servicePlanType: {
      storeSales: '店頭販売モデル',
      agentSales: '代理販売モデル',
      other: 'その他',
    },
    accountType: {
      savings: '普通口座',
      current: '当座口座',
      others: 'その他',
    },
  },
}
